import React, { useState } from "react";
import './opcoes-pagamento.css'

import { Dialog } from "primereact/dialog";

export default function DialogOpcoesPagamento({ open, setOpen, setMetodoPagamento }) {

  const mudarMetodoPagamento = (metodo) => {
    setMetodoPagamento(metodo)
    setOpen(false)
  }

  return (
    <Dialog visible={open} style={{ width: '50vw', marginTop: '40px' }} onHide={() => setOpen(false)} position={'top'} header='Escolha um método de pagamento'>
      <div className="opcoes-pagamento-cobranca">
        <button onClick={() => mudarMetodoPagamento('Pix')}>Pix</button>
        <button onClick={() => mudarMetodoPagamento('Cartão de Crédito')}>Cartão de Crédito</button>
        <button onClick={() => mudarMetodoPagamento('Boleto')}>Boleto</button>
      </div>
    </Dialog>
  )
}